/* eslint-disable react/require-default-props */
import React, { useState } from 'react';

import {
  Stack,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  IconButton,
  Select,
  HStack,
} from '@chakra-ui/react';
import { Search } from 'react-feather';

type FilterFieldOption = {
  value: string;
  label: string;
};

type SearchInputProp = {
  label: string;
  onSubmit?: () => void;
  input: {
    placeholder: string;
    value: string;
    onChange: (text: string) => void;
  };
  filterField?: {
    value: string;
    onChange: (field: string) => void;
    options: FilterFieldOption[];
  };
};

const SearchInput = ({
  label,
  onSubmit,
  input,
  filterField,
}: SearchInputProp): React.ReactElement => {
  const [typedValue, setTypedValue] = useState(input.value);

  const handleSubmit = (event: React.FormEvent<HTMLDivElement>): void => {
    event.preventDefault();
    input.onChange(typedValue);
    onSubmit?.();
  };

  const handleFieldChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    filterField?.onChange(e.target.value);
    setTypedValue('');
    input.onChange('');
  };

  return (
    <Stack
      as="form"
      spacing={4}
      direction={['column']}
      py={4}
      onSubmit={handleSubmit}
      width="100%"
    >
      <Text fontSize="lg">{label}</Text>
      <HStack spacing={2} align="stretch">
        {filterField && (
          <Select
            value={filterField.value}
            onChange={handleFieldChange}
            width="180px"
            flexShrink={0}
          >
            <option value="">Todos os campos</option>
            {filterField.options.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Select>
        )}
        <InputGroup flex="1">
          <Input
            placeholder={input.placeholder}
            value={typedValue}
            onChange={(event: any) => setTypedValue(event.target.value)}
          />
          <InputRightElement width="4.5rem">
            <IconButton
              aria-label="Pesquisar"
              icon={<Search size={18} />}
              size="sm"
              type="submit"
              colorScheme="blue"
            />
          </InputRightElement>
        </InputGroup>
      </HStack>
    </Stack>
  );
};

export { SearchInput };
